import { clsx } from 'clsx';
import * as React from 'react';

import styles from './MetaRow.css';
import { EMessageType } from '../../../../types/messageType';
import { EUserColor } from '../../../../types/userName';

interface IMetaRowProps {
  messageType: EMessageType;
  withBackground?: boolean;
  userColor?: EUserColor;
  className?: string;
}

export const MetaRow: React.FC<React.PropsWithChildren<IMetaRowProps>> = ({
  children,
  messageType,
  withBackground = false,
  userColor,
  className,
}) => {
  return (
    <div
      className={clsx(styles['meta'], className, {
        [styles['meta_type_outcoming']]: messageType === EMessageType.Outcoming && !withBackground,
        [styles['meta_type_incoming']]:
          (messageType === EMessageType.Incoming || messageType === EMessageType.Unread) && !withBackground,
        [styles['meta_background']]: withBackground,
        [styles[`meta_theme_${userColor}`]]: userColor && !withBackground,
      })}
    >
      {children}
    </div>
  );
};
